module.exports = "<timepicker\n    ng-model=\"model[options.key]\"\n    ng-required=\"to.required\"\n    hour-step=\"to.hourStep\"\n    minute-step=\"to.minuteStep\"\n    show-meridian=\"to.showMeridian\"></timepicker>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/timeInput.html
 ** module id = 536
 ** module chunks = 0
 **/